import {
    CALCULATE_LOAN_FAIL,
    CALCULATE_LOAN_SUCCESS,
    RESET_LOAN_CALCULATE_ACTION_STATE,
    RESET_LOAN_CALCULATE_STATE,
} from "./actionTypes"

const INIT_STATE = {
    calculateResult: [],
    error: [],
}

const LoanCalculate = (state = INIT_STATE, action) => {
    switch (action.type) {
        case CALCULATE_LOAN_SUCCESS:
            return {
                ...state,
                calculateResult: action.payload
            }
        case CALCULATE_LOAN_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_LOAN_CALCULATE_ACTION_STATE:
            return {
                ...state,
                calculateResult: [],
                error: [],
            }
        case RESET_LOAN_CALCULATE_STATE:
            return {
                ...state,
                calculateResult: [],
                error: [],
            }
        default:
            return state
    }
}

export default LoanCalculate
